module.exports = __webpack_public_path__ + "static/10400556_21574422223_7394_n-cb10e24d14bcbf895986ab0c854d8e9f.jpg";